import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PIMCORE_CONTENT_BASE_URL } from '../../utils/Pimcore';
import {
    buildDocumentRoute,
    useApplicationsDocuments,
} from '../../graphql/pimcore/modules/documents/contexts/ApplicationsDocumentsProvider';
import { useLocale } from '../../contexts/LocaleProvider';
import ResponsiveIframe from '../common/ResponsiveIframe';
import DocumentPage from '../../graphql/pimcore/modules/documents/types/DocumentPage';
import { NOT_FOUND_PATH } from '../../utils/ProjectUrls';
import './page.css';

interface PageParams extends Record<string, string | undefined> {
    id: string;
}

function Page() {
    const params = useParams<PageParams>();
    const navigate = useNavigate();
    const { locale } = useLocale();
    const { rootDocument, loading, error, findLocalizedDocumentById } = useApplicationsDocuments();
    const [document, setDocument] = useState<DocumentPage | null>(null);

    const { id } = params;

    useEffect(() => {
        if (!id) {
            navigate(NOT_FOUND_PATH);
            return;
        }

        if (loading) {
            return; // Still loading, do not navigate away
        }

        if (error) {
            navigate(NOT_FOUND_PATH);
            return;
        }

        if (rootDocument) {
            const document = findLocalizedDocumentById(id);
            if (!document) {
                navigate(NOT_FOUND_PATH); // FIXME: Redirect to 404 page
                return;
            }
            if (document.id !== id) {
                const newRoute = document ? buildDocumentRoute(document) : NOT_FOUND_PATH;
                navigate(newRoute);
                return;
            }

            setDocument(document);
        }
    }, [id, rootDocument, loading, error, navigate, locale, findLocalizedDocumentById]);

    if (loading || !document) {
        return null;
    }

    const url = `${PIMCORE_CONTENT_BASE_URL}${document.fullpath}`;

    return (
        <div className="page-iframe-container">
            <ResponsiveIframe url={url} />
        </div>
    );
}

export default Page;
